import axios from 'axios'
import { TRANSMITIR_EMISSAO_CTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function transmitirCte (parametros) {

  const url = `${URL}/emissao-cte/transmitir-cte`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: TRANSMITIR_EMISSAO_CTE,
        payload: response

      })
  );
}
